// extracted by mini-css-extract-plugin
export default {"container":"oK-z","topReviewHeading":"pK-z","criticalReview":"qK-z","favorableReview":"rK-z","vsSeparator":"sK-z"};